import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4777f159"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card Filter-card" }
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"20px"}
}
const _hoisted_3 = { class: "Filter-control" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "План", -1))
const _hoisted_5 = {
  key: 0,
  class: "card",
  style: {"margin":"15px 0"}
}
const _hoisted_6 = {
  key: 0,
  class: "card-body"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Номер заказа", -1))
const _hoisted_8 = {
  key: 0,
  class: "dx-button-text"
}
const _hoisted_9 = {
  key: 1,
  class: "dx-button-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxButton = _resolveComponent("DxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_CatalogueSelectControl, {
          class: "ModelField-selectControl",
          stylingMode: "outlined",
          filters: [{ column: 'stateDescription', value: 'Решение найдено' }],
          id: _ctx.model.planId,
          "onUpdate:id": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.planId) = $event)),
          desc: _ctx.model.planDescription,
          "onUpdate:desc": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.planDescription) = $event)),
          keyField: "id",
          displayDescField: "name",
          catalogueComponentName: "journals/PlanJournal/PlanJournal",
          hasEmptyValue: true,
          searchPanelVisible: true,
          onChanged: _ctx.onPlanChange
        }, null, 8, ["id", "desc", "onChanged"])
      ]),
      (_ctx.showOptions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.hasOrder)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _hoisted_7,
                    _createVNode(_component_DxSelectBox, {
                      class: "ModelField-control",
                      items: _ctx.options.orders,
                      "display-expr": "number",
                      "value-expr": "number",
                      value: _ctx.selectedOptions.orderNum,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedOptions.orderNum) = $event)),
                      "search-enabled": true,
                      stylingMode: "outlined",
                      "show-clear-button": true,
                      onValueChanged: _ctx.onFilterChange
                    }, null, 8, ["items", "value", "onValueChanged"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_DxButton, {
        disabled: !_ctx.model.planId,
        class: "Plan-reportButton",
        type: "default",
        onClick: _ctx.onReport,
        "styling-mode": "outlined"
      }, {
        content: _withCtx(() => [
          _createElementVNode("span", null, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Сформировать"))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "Остановить"))
          ])
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_DxButton, {
            key: 1,
            disabled: !_ctx.model.planId,
            type: "normal",
            icon: "download",
            style: {"margin-left":"5px"},
            onClick: _ctx.onDownload,
            hint: "Скачать отчет в виде pdf документа"
          }, null, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}